import 'svelte/internal/disclose-version';

Register[$.FILENAME] = 'src/pages/Register.svelte';

import * as $ from 'svelte/internal/client';
import Field from "../components/Field.svelte";
import api from "../lib/api.js";
import { session, setUser } from "../lib/session.svelte.js";
import { navigate } from "../lib/router.svelte.js";
import { toastSuccess } from "../lib/toast.svelte.js";

var root = $.add_locations(
	$.from_html(`<div class="sent svelte-xq186r"><div class="mark svelte-xq186r" aria-hidden="true">✉️</div> <h1 class="svelte-xq186r">Check your inbox</h1> <p class="svelte-xq186r">We sent a confirmation link to <strong> </strong>. Click it and you're all set —
          the link is good for 24 hours.</p> <button type="button" class="link svelte-xq186r">Didn't arrive? Send it again</button> <a class="primary svelte-xq186r" href="/login">Back to log in</a></div>`),
	Register[$.FILENAME],
	[
		[
			43,
			6,
			[[44, 8], [45, 8], [46, 8, [[47, 41]]], [50, 8], [53, 8]]
		]
	]
);

var root_1 = $.add_locations($.from_html(`<a class="google svelte-xq186r" href="/api/auth/google/login" data-native=""><svg viewBox="0 0 24 24" aria-hidden="true" class="svelte-xq186r"><path fill="#4285F4" d="M21.6 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.4a4.6 4.6 0 0 1-2 3v2.5h3.2c1.9-1.7 3-4.3 3-7.3Z"></path><path fill="#34A853" d="M12 22c2.7 0 5-.9 6.6-2.5l-3.2-2.5c-.9.6-2 1-3.4 1-2.6 0-4.8-1.8-5.6-4.1H3.1v2.6A10 10 0 0 0 12 22Z"></path><path fill="#FBBC05" d="M6.4 13.9a6 6 0 0 1 0-3.8V7.5H3.1a10 10 0 0 0 0 9l3.3-2.6Z"></path><path fill="#EA4335" d="M12 5.9c1.5 0 2.8.5 3.8 1.5l2.8-2.8A10 10 0 0 0 3.1 7.5l3.3 2.6C7.2 7.7 9.4 5.9 12 5.9Z"></path></svg> Sign up with Google</a> <div class="or svelte-xq186r"><span>or</span></div>`, 1), Register[$.FILENAME], [
	[60, 8, [[61, 10, [[62, 12], [63, 12], [64, 12], [65, 12]]]]],
	[69, 8, [[69, 24]]]
]);

var root_2 = $.add_locations($.from_html(`<p class="error svelte-xq186r"> </p>`), Register[$.FILENAME], [[85, 19]]);
var root_3 = $.add_locations($.from_html(`<h1 class="svelte-xq186r">Join the neighbourhood</h1> <p class="sub svelte-xq186r">Save places, write reviews, and get suggestions that fit how you actually eat.</p> <!> <form class="svelte-xq186r"><!> <!> <!> <!> <button class="primary svelte-xq186r" type="submit"> </button></form> <p class="links svelte-xq186r">Already have an account? <a href="/login" class="svelte-xq186r">Log in</a></p>`, 1), Register[$.FILENAME], [[56, 6], [57, 6], [72, 6, [[87, 8]]], [90, 6, [[90, 48]]]]);
var root_4 = $.add_locations($.from_html(`<div class="auth svelte-xq186r"><div class="card svelte-xq186r"><!></div></div>`), Register[$.FILENAME], [[40, 0, [[41, 2]]]]);

const $$css = {
	hash: 'svelte-xq186r',
	code: '\n  .auth.svelte-xq186r { display: grid; place-items: center; padding: 48px 0 64px; }\n  .card.svelte-xq186r {\n    width: min(440px, 100%);\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius-lg);\n    padding: 32px;\n    box-shadow: var(--shadow);\n  }\n  h1.svelte-xq186r { font-size: 1.7rem; }\n  .sub.svelte-xq186r { margin: 8px 0 22px; color: var(--ink-soft); font-size: 0.94rem; line-height: 1.5; }\n\n  form.svelte-xq186r { display: flex; flex-direction: column; gap: 14px; }\n  .primary.svelte-xq186r {\n    margin-top: 4px;\n    display: inline-block;\n    text-align: center;\n    background: var(--accent);\n    color: #fff;\n    border: none;\n    font-weight: 600;\n    font-size: 0.96rem;\n    padding: 13px;\n    border-radius: var(--radius-pill);\n    cursor: pointer;\n  }\n  .primary.svelte-xq186r:hover:not(:disabled) { background: var(--accent-dark); }\n  .primary.svelte-xq186r:disabled { opacity: 0.6; cursor: progress; }\n\n  .google.svelte-xq186r {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    border: 1px solid var(--line-strong);\n    border-radius: var(--radius-pill);\n    padding: 12px;\n    font-weight: 600;\n    font-size: 0.94rem;\n  }\n  .google.svelte-xq186r:hover { border-color: var(--accent); }\n  .google.svelte-xq186r svg:where(.svelte-xq186r) { width: 19px; height: 19px; }\n\n  .or.svelte-xq186r { display: flex; align-items: center; gap: 12px; margin: 18px 0; color: var(--ink-faint); font-size: 0.82rem; }\n  .or.svelte-xq186r::before, .or.svelte-xq186r::after { content: ""; flex: 1; height: 1px; background: var(--line); }\n\n  .error.svelte-xq186r { margin: 0; color: var(--accent-dark); font-size: 0.87rem; }\n  .links.svelte-xq186r { margin: 20px 0 0; font-size: 0.88rem; color: var(--ink-soft); }\n  .links.svelte-xq186r a:where(.svelte-xq186r) { color: var(--accent); font-weight: 600; }\n\n  .sent.svelte-xq186r { text-align: center; display: flex; flex-direction: column; align-items: center; gap: 10px; }\n  .sent.svelte-xq186r .mark:where(.svelte-xq186r) { font-size: 2.6rem; }\n  .sent.svelte-xq186r p:where(.svelte-xq186r) { margin: 0; color: var(--ink-soft); line-height: 1.6; }\n  .link.svelte-xq186r {\n    border: none;\n    background: none;\n    color: var(--accent);\n    font-weight: 600;\n    cursor: pointer;\n    text-decoration: underline;\n    font-size: 0.88rem;\n  }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function Register($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Register);
	$.append_styles($$anchor, $$css);

	let displayName = $.tag($.state(""), 'displayName');
	let email = $.tag($.state(""), 'email');
	let password = $.tag($.state(""), 'password');
	let busy = $.tag($.state(false), 'busy');
	let error = $.tag($.state(""), 'error');
	let sentTo = $.tag($.state(""), 'sentTo');

	async function submit(event) {
		event.preventDefault();
		$.set(error, "");
		$.set(busy, true);

		try {
			const response = (await $.track_reactivity_loss(api.register({
				email: $.get(email).trim(),
				password: $.get(password),
				displayName: $.get(displayName).trim()
			})))();

			if (response?.user) {
				(await $.track_reactivity_loss(setUser(response.user)))();
				toastSuccess("You're in!");
				navigate("/");
			} else {
				$.set(sentTo, $.get(email).trim(), true);
			}
		} catch(e) {
			$.set(error, e.message ?? "Couldn't create that account.", true);
		} finally {
			$.set(busy, false);
		}
	}

	var $$exports = { ...$.legacy_api() };
	var div = root_4();
	var div_1 = $.child(div);
	var node = $.child(div_1);

	{
		var consequent = ($$anchor) => {
			var div_2 = root();
			var p = $.sibling($.child(div_2), 4);
			var strong = $.sibling($.child(p));
			var text = $.child(strong, true);

			$.reset(strong);
			$.next();
			$.reset(p);

			var button = $.sibling(p, 2);

			$.next(2);
			$.reset(div_2);
			$.template_effect(() => $.set_text(text, $.get(sentTo)));

			$.delegated('click', button, function click() {
				return api.resendVerification($.get(sentTo));
			});

			$.append($$anchor, div_2);
		};

		var alternate = ($$anchor) => {
			var fragment = root_3();
			var node_1 = $.sibling($.first_child(fragment), 4);

			{
				var consequent_1 = ($$anchor) => {
					var fragment_1 = root_1();

					$.next(2);
					$.append($$anchor, fragment_1);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if (session.googleEnabled) $$render(consequent_1);
					}),
					'if',
					Register,
					59,
					6
				);
			}

			var form = $.sibling(node_1, 2);
			var node_2 = $.child(form);

			$.add_svelte_meta(
				() => Field(node_2, {
					label: 'Your name',
					name: 'displayName',
					placeholder: 'How neighbours will see you',
					autocomplete: 'name',
					get value() {
						return $.get(displayName);
					},

					set value($$value) {
						$.set(displayName, $$value, true);
					}
				}),
				'component',
				Register,
				73,
				8,
				{ componentTag: 'Field' }
			);

			var node_3 = $.sibling(node_2, 2);

			$.add_svelte_meta(
				() => Field(node_3, {
					label: 'Email',
					name: 'email',
					type: 'email',
					required: true,
					autocomplete: 'email',
					placeholder: 'you@example.com',
					get value() {
						return $.get(email);
					},

					set value($$value) {
						$.set(email, $$value, true);
					}
				}),
				'component',
				Register,
				74,
				8,
				{ componentTag: 'Field' }
			);

			var node_4 = $.sibling(node_3, 2);

			$.add_svelte_meta(
				() => Field(node_4, {
					label: 'Password',
					name: 'password',
					type: 'password',
					required: true,
					autocomplete: 'new-password',
					hint: 'At least 8 characters, with a number or symbol.',
					get value() {
						return $.get(password);
					},

					set value($$value) {
						$.set(password, $$value, true);
					}
				}),
				'component',
				Register,
				75,
				8,
				{ componentTag: 'Field' }
			);

			var node_5 = $.sibling(node_4, 2);

			{
				var consequent_2 = ($$anchor) => {
					var p_1 = root_2();
					var text_1 = $.child(p_1, true);

					$.reset(p_1);
					$.template_effect(() => $.set_text(text_1, $.get(error)));
					$.append($$anchor, p_1);
				};

				$.add_svelte_meta(
					() => $.if(node_5, ($$render) => {
						if ($.get(error)) $$render(consequent_2);
					}),
					'if',
					Register,
					85,
					8
				);
			}

			var button_1 = $.sibling(node_5, 2);
			var text_2 = $.child(button_1, true);

			$.reset(button_1);
			$.reset(form);
			$.next(2);

			$.template_effect(() => {
				button_1.disabled = $.get(busy);
				$.set_text(text_2, $.get(busy) ? "Creating…" : "Create account");
			});

			$.event('submit', form, submit);
			$.append($$anchor, fragment);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.get(sentTo)) $$render(consequent); else $$render(alternate, -1);
			}),
			'if',
			Register,
			42,
			4
		);
	}

	$.reset(div_1);
	$.reset(div);
	$.append($$anchor, div);

	return $.pop($$exports);
}

$.delegate(['click']);